import React from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import GoogleMapWrapper from 'core/components//maps/GoogleMapWrapper'
import styled from 'styled-components'
import { Row, Col } from 'core/components/ui'
import PageLoading from 'core/components/page-loading'
import SVG from 'core/components/svg'
import svg from 'assets/svg'
import { font, greys } from 'assets/themes/theme-default'
import { stockShape } from '../../shapes'

const Icon = styled(SVG)`
  width: 16px;
  height: 16px;
  fill: ${greys.light4};
  vertical-align: middle;
  margin: 0 8px 0 0;
`

const PointOfSalesWrapper = styled.div`
  background-color: ${props => props.theme.colors.color2.bg};
  color: ${greys.light4};
  padding: 10px 25px;
  height: 100%;
`

const PointOfSalesDatasWrapper = styled.div`
  margin: 10px 0;
`

const PointOfSalesTitle = styled.h4`
  font-size: ${font.size.base};
  text-transform: uppercase;
  color: ${greys.light4};
`
const PointOfSalesDatas = styled.p`
  color: ${greys.light4};
  font-size: ${font.size.sm};
  margin: 0;
  a {
    color: ${greys.light4};
  }
`

const Distributor = props => {
  const { stock, loading } = props

  if (loading) return <PageLoading data-test="stock-vehicles-detail-distributor-loading" />

  const { selectedVehicle } = stock

  const { pointOfSales } = selectedVehicle

  const mailto = pointOfSales ? `mailto:${pointOfSales.email}` : null

  const zipCodeCity = pointOfSales ? `${pointOfSales.postalCode} ${pointOfSales.city}` : null

  const renderPointOfSales = (
    <>
      {pointOfSales && (
        <PointOfSalesWrapper data-test="stock-vehicles-detail-distributor-PointOfSalesWrapper">
          <PointOfSalesDatasWrapper>
            <PointOfSalesTitle data-test="stock-vehicles-detail-distributor-PointOfSales-name">
              {pointOfSales.entity}
            </PointOfSalesTitle>
            <PointOfSalesTitle data-test="stock-vehicles-detail-distributor-PointOfSales-name">
              {pointOfSales.name}
            </PointOfSalesTitle>
            {pointOfSales.address1 !== undefined && (
              <PointOfSalesDatas data-test="stock-vehicles-detail-distributor-PointOfSales-adress1">
                {pointOfSales.address1}
              </PointOfSalesDatas>
            )}
            {pointOfSales.address2 !== undefined && (
              <PointOfSalesDatas data-test="stock-vehicles-detail-distributor-PointOfSales-adress2">
                {pointOfSales.address2}
              </PointOfSalesDatas>
            )}
            {pointOfSales.complementaryAddress1 !== undefined && (
              <PointOfSalesDatas data-test="stock-vehicles-detail-distributor-PointOfSales-adress3">
                {pointOfSales.complementaryAddress1}
              </PointOfSalesDatas>
            )}
            {pointOfSales.complementaryAddress2 !== undefined && (
              <PointOfSalesDatas data-test="stock-vehicles-detail-distributor-PointOfSales-adress3">
                {pointOfSales.complementaryAddress2}
              </PointOfSalesDatas>
            )}
            {pointOfSales.postalCode !== undefined && pointOfSales.city !== undefined && (
              <PointOfSalesDatas data-test="stock-vehicles-detail-distributor-PointOfSales-ZipCodeCityWrapper">
                {zipCodeCity}
              </PointOfSalesDatas>
            )}
          </PointOfSalesDatasWrapper>
          <PointOfSalesDatasWrapper>
            <PointOfSalesTitle>
              <FormattedMessage
                id="tradeIn-distributor-pointofsales-contact-title-2"
                data-test="stock-vehicles-detail-distributor-PointOfSales-contact-title"
              />
            </PointOfSalesTitle>
            {pointOfSales.email !== undefined && (
              <PointOfSalesDatas>
                <Icon svg={svg.letter} />
                <a
                  href={mailto}
                  data-test="stock-vehicles-detail-distributor-PointOfSales-contact-email"
                >
                  {pointOfSales.email}
                </a>
              </PointOfSalesDatas>
            )}
            {pointOfSales.phone !== undefined && (
              <PointOfSalesDatas>
                <Icon svg={svg.phone} />
                <span data-test="stock-vehicles-detail-distributor-PointOfSales-contact-phone1">
                  {pointOfSales.phone}
                </span>
              </PointOfSalesDatas>
            )}
          </PointOfSalesDatasWrapper>
        </PointOfSalesWrapper>
      )}
    </>
  )

  return (
    <Row
      type="flex"
      style={{ justifyContent: 'stretch' }}
      data-test="component-stock-vehicles-detail-distributor"
    >
      <Col span={12}>
        {pointOfSales &&
          pointOfSales.lat &&
          pointOfSales.lng(
            <GoogleMapWrapper
              aMarkers={[
                {
                  lat: Number(pointOfSales.lat),
                  lng: Number(pointOfSales.lng)
                }
              ]}
              isLoading={false}
              hasError={false}
              region={0}
              styles={0}
              bMarkerClusterer={false}
              height={350}
              data-test="stock-vehicles-detail-distributor-GoogleMapWrapper"
            />
          )}
      </Col>
      <Col span={12}>{renderPointOfSales}</Col>
    </Row>
  )
}

Distributor.propTypes = {
  stock: stockShape.isRequired,
  loading: PropTypes.bool.isRequired
}

export default Distributor
